/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface PersonAddressRef
 */
export interface PersonAddressRefOptional {
  /**
   *
   * @type {number}
   * @memberof PersonAddressRef
   */
  personAddressAssignId?: number;
}

export interface PersonAddressRef extends PersonAddressRefOptional {
  /**
   *
   * @type {number}
   * @memberof PersonAddressRef
   */
  personAddressAssignId: number;
}

export interface PersonAddressRefTrackedI {
  /**
   *
   * @type {number}
   * @memberof PersonAddressRef
   */
  personAddressAssignId?: number;
  personAddressAssignIdIsSet: boolean;
}

transformDatesMap.set(
  "PersonAddressRef",
  function (model: PersonAddressRef) {},
);

export type PersonAddressRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  personAddressAssignId: PropertyMeta<MetaTypeBase<number>>;
}>;

export var PersonAddressRefMeta: PersonAddressRefMetaI =
  {} as PersonAddressRefMetaI;
PersonAddressRefMeta = typeMeta("PersonAddressRef", {
  personAddressAssignId: propertyMeta(
    "personAddressAssignId",
    false,
    true,
    true,
    MetaTypesBase.number,
  ),
});

const metaI = PersonAddressRefMeta;

registerMeta(() => {});

export class PersonAddressRefTracked implements PersonAddressRefTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  personAddressAssignId__I?: number = undefined;

  get personAddressAssignIdIsSet() {
    return this.personAddressAssignId !== undefined;
  }
  set personAddressAssignIdIsSet(v: boolean) {}
  set personAddressAssignId(v: undefined | number) {
    if (v !== undefined) {
      this.personAddressAssignId__I = v;
      this.personAddressAssignIdIsSet = true;
    } else {
      this.personAddressAssignId__I = v || undefined;
      this.personAddressAssignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personAddressAssignId() {
    return this.personAddressAssignId__I;
  }
  constructor(config?: PersonAddressRefOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (
      this.personAddressAssignIdIsSet == true &&
      other?.personAddressAssignIdIsSet == true
    )
      return this.personAddressAssignId == other.personAddressAssignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.personAddressAssignId) {
      this.personAddressAssignIdIsSet = true;
    }
  }
  assignFrom(
    config: PersonAddressRefOptional,
    options?: AssignOptions,
  ): PersonAddressRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.personAddressAssignId &&
      this.personAddressAssignIdApplyFilter(optionsRequired.filter)
    ) {
      this.personAddressAssignId = config.personAddressAssignId;
      if (optionsRequired.unassign) this.personAddressAssignIdIsSet = false;
      else this.personAddressAssignIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonAddressRefTrackedI {
    const cloned = {} as PersonAddressRefTrackedI;
    if (
      this.personAddressAssignIdIsSetDeep() &&
      this.personAddressAssignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personAddressAssignIdIsSet = true;
      cloned.personAddressAssignId = this.personAddressAssignId;
    } else {
      //cloned.personAddressAssignIdIsSet = false
    }
    if (!isDeleted(this) && !this.personAddressAssignIdIsSet)
      updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonAddressRefTrackedI {
    if (!this.personAddressAssignIdApplyFilter(filter))
      this.personAddressAssignIdIsSet = false;

    return this;
  }
  personAddressAssignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAddressRefMeta.personAddressAssignId,
      PersonAddressRefMeta,
      this.personAddressAssignId,
      this,
    );
  }
  personAddressAssignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.personAddressAssignIdIsSet &&
      this.personAddressAssignIdApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.personAddressAssignIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
